// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ### Code for AdminDashboard component ### */

.user-table {
  text-align: center;
  font-size: 1.2vmax;
  /* background:linear-gradient(to right,rgb(138, 181, 207),rgb(233, 228, 228)); */
  /* background:rgb(138, 181, 207) !important; */
  background: rgb(3, 99, 125) !important;

  padding: 0.5vmax 1vmax;
}
.user-table > tr {
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.user-table > tr > th {
  color: white;
  padding: 1.5vmin 1vmin;
}

.user-table > tr > td {
  padding: 0 1vmin;
}

.user-action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1vmax;
}
.user-action-buttons > span {
  padding: 0.5vmax 1vmax;
  border-radius: 4px;
  margin: 0.5vmax 0;
  font-size: 2vmin;
  cursor: pointer;
  font-weight: 650;
}
.user-action-buttons > :first-child {
  color: rgb(19, 17, 17);
}

.user-action-buttons > :last-child {
  background-color: rgb(67, 65, 64);
  color: white;
}
.user-action-buttons > :first-child:hover {
  background-color: rgb(253, 137, 27);
}
.user-action-buttons > :last-child:hover {
  background-color: rgb(38, 37, 36);
}

.dashboard-container {
  display: flex;
  height: 100vh;
}

.admin-sidebar {
  width: 250px;
  background-color: #f4f4f4;
  padding: 4vmin 0;
}

.tab-button {
  color: #203864;
}
.tab-button.active {
  color: red;
}

.content {
  flex-grow: 1;
  padding: 16px;
}

.section-container {
  display: flex;
  gap: 24px;
}

.access-section {
  flex: 1 1;
  height: -moz-fit-content;
  height: fit-content;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.search-input{
 
}
.search-input .MuiOutlinedInput-root{
  border-radius: 18px;
  padding: 0;
}

.search-input .MuiOutlinedInput-root fieldset{
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/AdminDashboard.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gFAAgF;EAChF,8CAA8C;EAC9C,sCAAsC;;EAEtC,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,wBAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;AAEA;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* ### Code for AdminDashboard component ### */\n\n.user-table {\n  text-align: center;\n  font-size: 1.2vmax;\n  /* background:linear-gradient(to right,rgb(138, 181, 207),rgb(233, 228, 228)); */\n  /* background:rgb(138, 181, 207) !important; */\n  background: rgb(3, 99, 125) !important;\n\n  padding: 0.5vmax 1vmax;\n}\n.user-table > tr {\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n.user-table > tr > th {\n  color: white;\n  padding: 1.5vmin 1vmin;\n}\n\n.user-table > tr > td {\n  padding: 0 1vmin;\n}\n\n.user-action-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1vmax;\n}\n.user-action-buttons > span {\n  padding: 0.5vmax 1vmax;\n  border-radius: 4px;\n  margin: 0.5vmax 0;\n  font-size: 2vmin;\n  cursor: pointer;\n  font-weight: 650;\n}\n.user-action-buttons > :first-child {\n  color: rgb(19, 17, 17);\n}\n\n.user-action-buttons > :last-child {\n  background-color: rgb(67, 65, 64);\n  color: white;\n}\n.user-action-buttons > :first-child:hover {\n  background-color: rgb(253, 137, 27);\n}\n.user-action-buttons > :last-child:hover {\n  background-color: rgb(38, 37, 36);\n}\n\n.dashboard-container {\n  display: flex;\n  height: 100vh;\n}\n\n.admin-sidebar {\n  width: 250px;\n  background-color: #f4f4f4;\n  padding: 4vmin 0;\n}\n\n.tab-button {\n  color: #203864;\n}\n.tab-button.active {\n  color: red;\n}\n\n.content {\n  flex-grow: 1;\n  padding: 16px;\n}\n\n.section-container {\n  display: flex;\n  gap: 24px;\n}\n\n.access-section {\n  flex: 1;\n  height: fit-content;\n  background: #fff;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.search-input{\n \n}\n.search-input .MuiOutlinedInput-root{\n  border-radius: 18px;\n  padding: 0;\n}\n\n.search-input .MuiOutlinedInput-root fieldset{\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
